import {
  QBox,
  QFormControl,
  QSelect,
  QSelectItem,
  QSelectPlaceholder,
  QText,
} from '@qualio/ui-components';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { getActionValueLabelMap } from '../constants';

export const ActionFilter = () => {
  const { t } = useTranslation();
  const actionOptions: readonly QSelectItem[] = Object.entries(
    getActionValueLabelMap(),
  ).map(([value, label]) => ({ value, label }));

  return (
    <QFormControl label={t('labels.yourActions')}>
      <Controller
        name="action"
        render={({ field: { onChange, value, ...field } }) => {
          return (
            <QBox data-cy="workspace-actions-filter">
              <QSelect
                {...field}
                options={actionOptions}
                value={value ?? null}
                onChange={(item) => {
                  onChange(item?.value ?? null);
                }}
                isClearable={true}
                clearInputOnSelect={value == null}
              >
                <QSelectPlaceholder>
                  <QText>{t('forms.filterByAction')}</QText>
                </QSelectPlaceholder>
              </QSelect>
            </QBox>
          );
        }}
      />
    </QFormControl>
  );
};
